import Box from "../components/Box";
import Select from "../components/Select";
import React, { useState } from "react";
import OrderList from "../components/OrderList";
import SearchBar from "../components/SearchBar";

const currentYear = new Date().getFullYear();

const DATE_FILTERS = [
  "Last 60 days",
  currentYear,
  currentYear - 1,
  currentYear - 2,
];

interface Props {
  customerId?: string;
}

export const Orders = ({ customerId }: Props) => {
  const [searchKeyword, setSearchKeyword] = useState("");
  const [dateFilter, setDateFilter] = useState(DATE_FILTERS[0]);

  return (
    <div className="gpc__orders">
      <Box className="gpc__order-box">
        <div className="gpc__box-header gpc__orders-list__header">
          <h2 className="gpc__page-title">My Orders</h2>
          <SearchBar onChange={(val) => setSearchKeyword(val)} />
        </div>
        <div className="gpc__time-filter">
          <p>View orders from:</p>
          <Select
            items={DATE_FILTERS}
            onChange={(e) => {
              setDateFilter(e);
            }}
            selectedItem={dateFilter}
            classNamePrefix="gpc__time-filter__select"
          />
        </div>
        <OrderList
          dateFilter={dateFilter}
          searchKeyword={searchKeyword}
          customerId={customerId}
        />

        {__SUPPORT_URL__ && (
          <div className="gpc__contact-button">
            <p>Need help with an order?</p>
            <a
              href={__SUPPORT_URL__}
              className="gpc__button contact-button"
              target="_top"
              rel="noreferrer"
            >
              Contact us
            </a>
          </div>
        )}
      </Box>
    </div>
  );
};

export default Orders;
